module.exports = __webpack_public_path__ + "static/sport/captain.b4d6f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/captain.png
// module id = F0vm
// module chunks = 0